import React, { Component } from 'react'
import MaterialIcon, { colorPalette } from 'material-icons-react';
import { connect } from "react-redux";
import { logout } from "reducers/application/applicationActions";
import Auth from "../../auth/Auth";
import history from 'routes/History/history';
import { NO_PIC_PROFILE } from "../../constants/profileConstant";
import HttpClient from "../../utils/HttpClient/HttpClient";
import $ from 'jquery';

class Drawer extends Component {

    profileMenuItems;
    user;
    auth;
    httpClient;
    constructor(props) {
        super(props);
        this.auth = new Auth();
        this.user = this.auth.getUser();
        this.state = {
            preloaded: false,
            drawerOpen: false,
            profilOpen: false,
            pictureProfile: this.user.photoUrl,
            notificationOpen: false,
            notifications: null,
        }
        this.profileMenuItems = [
            {
                id: 1,
                name: "Ver perfil",
                path: "/profile",
                onClick: this.goToPage
            },
            {
                id: 3,
                name: "Solicitudes de Desembolso",
                path: "/disbursements",
                onClick: this.goToPage
            },
            {
                id: 4,
                name: "Cerrar sesión",
                onClick: this.onLogOut
            }
        ]

        this.httpClient = new HttpClient(true);
    }

    componentDidMount() {

        window.addEventListener("focus", (event) => {
            console.log("focus from drawer");
            this.forceUpdate();
        }, false);

        setTimeout(() => { // avoid animation on page load
            this.setState({ preloaded: true });
        }, 500);

        $(document).on("click", (event) => {
            if (event.target.classList.contains('notification-item')) {
                setTimeout(() => this.closeNotificationMenuIfOpen(), 200);
            } else {
                this.closeNotificationMenuIfOpen();
            }
        });
    }

    closeNotificationMenuIfOpen() {
        if (this.state.notificationOpen) {
            this.setState({ notificationOpen: false });
        }
    }

    onOpenClick() {
        this.setState({ drawerOpen: true });
    }

    onOverlayClick() {
        if (this.state.profilOpen) {
            this.setState({ profilOpen: false });
        } else if (this.state.drawerOpen) {
            this.setState({ drawerOpen: false });
        }
    }

    onMenuSelected(i) {
        this.props.onMenuSelected(i)
        this.closeDrawer();
    }

    closeDrawer = () => {
        this.setState({ drawerOpen: false });
    };

    goToPage(path) {
        history.push(path);
    }

    onLogOut = () => {
        this.props.logout();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.userPicture) {
            this.setState({ pictureProfile: nextProps.userPicture });
        }

        if (nextProps.notifications) {
            this.setState({ notifications: nextProps.notifications });
        }
    }

    /**
     *  Notification object
        {
            "id": 1042265,
            "status": "NOT_READ",
            "notification": {
                "id": 197,
                "date": 1539183363611,
                "title": "OGA TEST",
                "body": "Oga test body",
                "type": "GENERAL_INFORMATION",
                "user": null,
                "origin": "WEB",
                "status": "ENABLE",
                "paramId": 0
            },
            "userId": 188
        }
     */
    getNavBar = (defaultOpen) => {
        let navClass = defaultOpen ? "white_bg" : "navbar-light";
        let userProfilePicture = this.state.pictureProfile ? this.state.pictureProfile : NO_PIC_PROFILE;
        // let newNotification = this.state.notifications ? this.state.notifications.message : null;
        let userNotifications = this.auth.getNotifications().reverse();
        let notificationsUnreadCount = this.auth.getUnreadNotifications().length;
        let hasUnreadNotifications = notificationsUnreadCount > 0;
        let pulseClass = hasUnreadNotifications ? "pulse-button" : "no-not-unread-btn";
        let showSeeAllNotificationsButton = userNotifications.length > 1;
        let ulClass = showSeeAllNotificationsButton ? "footer-padding" : "";
        return (
            <nav className={`navbar ${navClass} sticky-top show`}>
                {
                    defaultOpen ? null :
                        <button className="navbar-toggler border-0" type="button" onClick={(e) => this.onOpenClick()}>
                            <svg width="32" height="32" viewBox="0 0 24 24" focusable="false" role="presentation">
                                <path d="M5 15h14v2H5zm0-8h14v2H5zm0 4h14v2H5z" fill="#515F78" fillRule="evenodd" />
                            </svg>
                        </button>
                }
                <div className="float-right">
                    <div className={`right-profile-menu transparent flex container-centered`}>
                        <h1 className="header">{this.user.completeName}</h1>

                        <div>
                            <button className={`btn ${pulseClass} rounded-circle notification-nav-btn dropdown-toggle`}
                                onClick={() => this.onNotificationButtonClick(notificationsUnreadCount)}>

                                {
                                    !hasUnreadNotifications ? null : <div className="not-count">{notificationsUnreadCount}</div>
                                }

                                <MaterialIcon size="20px" icon="notifications" />
                            </button>
                        </div>

                        {
                            !this.state.notificationOpen ? null :
                                <div className="not-container ">
                                    <div className="notification-nav-menu so-shadow border rounded">

                                        {

                                        }
                                        {
                                            userNotifications.length === 0 ?
                                                <div className="no-notification container-centered">
                                                    <div className="w-100 block">
                                                        <div className="block centered">
                                                            <MaterialIcon size="52px" icon="notification_important" />
                                                        </div>
                                                        <div className="block centered">
                                                            <small> No tiene notificaciones</small>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                <div className="scroll-y">
                                                    <ul className={`list-group ${ulClass}`}>
                                                        {
                                                            userNotifications.map((e, i) => {
                                                                return (
                                                                    <li key={i} className="list-group-item notification-item border-0 cursor"
                                                                        onClick={() => this.onNotificationItemClick(e)}>
                                                                        {
                                                                            !e.notification ? "error" :
                                                                                <div>
                                                                                    <h5>{e.notification.title}</h5>
                                                                                    {e.notification.body}
                                                                                </div>
                                                                        }

                                                                    </li>
                                                                )
                                                            })
                                                        }
                                                    </ul>
                                                </div>
                                        }
                                    </div>
                                </div>

                        }

                        <div className="dropdown profile" style={{
                            backgroundImage: `url('${userProfilePicture}')`,
                            backgroundPosition: 'center', backgroundSize: "cover", backgroundRepeat: "no-repeat"
                        }}>
                            <button className="btn bg-transparent dropdown-toggle" type="button" id="dropdownMenuButton"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            </button>
                            <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                {
                                    this.profileMenuItems.map((e, i) => {
                                        return (
                                            e.path ?
                                                <a key={i} className="dropdown-item" onClick={() => e.onClick(e.path)}>{e.name}</a>
                                                :
                                                <a key={i} className="dropdown-item" onClick={() => e.onClick()}>{e.name}</a>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        );
    };

    onPictureProfileChange(base64) {
        this.setState({ pictureProfile: base64 })
    }

    redirectToNotificationPage() {
        alert('redirectToNotificationPage');
    }

    onNotificationButtonClick(countOfUnread) {
        if (countOfUnread > 0) {
            this.httpClient.post("oga/notifications/asRead", this.auth.getAllUnreadNotificationIds());
            this.auth.setAllAsRead();
        }
        this.setState({ notificationOpen: !this.state.notificationOpen });
    }

    onNotificationItemClick(e) {
        alert("...")
        if (e.id && e.id === -1) {
            alert("...")
        }
    }

    redirectToDashboard() {
        history.push("/");
        this.closeDrawer();
    }

    render() {
        let isDesktop = this.props.threshold;
        let profilOpen = this.state.profilOpen;
        let drawerClass = isDesktop ? 'static-drawer ' : this.state.drawerOpen ? 'open-drawer ' : 'closed-drawer ';
        let overlayClass = (!isDesktop && this.state.drawerOpen) || profilOpen ? 'fade-show' : 'fade-hide';
        let defaultOpenClass = isDesktop ? 'drawer-margin' : '';
        let preloaded = this.state.preloaded ? '' : 'preload';

        let navBar = this.getNavBar(isDesktop);
        return (
            <div className={`flex ${preloaded}`}>

                <div className={`drawer-container default-drawer-bg ${drawerClass}`} >
                    <div className="left-drawer" />
                    <div className="drawer right-drawer">
                        <div className="drawer-right-container">
                            <div className="drawer-icon-container cursor" onClick={() => { this.redirectToDashboard() }}>
                                <svg width="85" height="85" viewBox="0 0 208 151" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M150.609 80.0134C138.421 80.0134 128.541 70.1334 128.541 57.9454C128.541 45.7574 138.421 35.8774 150.609 35.8774C162.797 35.8774 172.677 45.7574 172.677 57.9454C172.677 70.1334 162.797 80.0134 150.609 80.0134ZM93.2321 80.0134C81.0441 80.0134 71.1641 70.1334 71.1641 57.9454C71.1641 45.7574 81.0441 35.8774 93.2321 35.8774C105.42 35.8774 115.3 45.7574 115.3 57.9454C115.3 70.1334 105.42 80.0134 93.2321 80.0134ZM35.8548 80.0134C23.6668 80.0134 13.7868 70.1334 13.7868 57.9454C13.7868 45.7574 23.6668 35.8774 35.8548 35.8774C48.0428 35.8774 57.9228 45.7574 57.9228 57.9454C57.9228 70.1334 48.0428 80.0134 35.8548 80.0134ZM185.919 57.9454C185.919 38.4441 170.109 22.6361 150.609 22.6361C138.787 22.6361 128.329 28.4534 121.921 37.3734C115.512 28.4534 105.055 22.6361 93.2321 22.6361C81.4095 22.6361 70.9521 28.4534 64.5441 37.3734C62.2975 34.2468 59.5548 31.5041 56.4268 29.2574C65.3481 22.8481 71.1641 12.3907 71.1641 0.568083H57.9241C57.9241 12.7561 48.0428 22.6361 35.8548 22.6361C16.3548 22.6361 0.546814 38.4454 0.546814 57.9454C0.546814 77.4454 16.3548 93.2547 35.8548 93.2547C47.6775 93.2547 58.1348 87.4374 64.5441 78.5174C70.9521 87.4374 81.4095 93.2547 93.2321 93.2547C93.3028 93.2547 93.3721 93.2494 93.4428 93.2494V93.2547C105.631 93.2547 115.511 103.135 115.511 115.323C115.511 127.511 105.631 137.391 93.4428 137.391C81.2548 137.391 71.3735 127.511 71.3735 115.323C71.3735 115.311 71.3748 115.299 71.3748 115.285H58.1348C58.1348 115.299 58.1335 115.311 58.1335 115.323C58.1335 134.823 73.9415 150.632 93.4428 150.632C112.943 150.632 128.751 134.823 128.751 115.323C128.751 103.453 122.889 92.9614 113.909 86.5588C116.993 84.3268 119.699 81.6094 121.921 78.5174C128.329 87.4374 138.787 93.2547 150.609 93.2547C162.432 93.2547 172.889 87.4374 179.297 78.5174C185.707 87.4374 196.164 93.2547 207.987 93.2547V80.0134C195.799 80.0134 185.919 70.1334 185.919 57.9454Z" />
                                </svg>
                            </div>
                            <div className="drawer-list-container">
                                <ul className="list-group">
                                    {this.props.menuItems.map((menu, i) =>
                                        !menu.external ?
                                            (<li key={i} className={`list-group-item ${menu.selected ? "selected" : ""}`}
                                                onClick={() => this.onMenuSelected(i)}>
                                                <span className="drawer-menu-icon-span">
                                                    <span className="drawer-menu-icon-div">
                                                        <MaterialIcon icon={menu.icon} />
                                                    </span>
                                                </span>
                                                <span className="drawer-menu-txt-container">
                                                    <span className="drawer-menu-txt">{menu.name}</span>
                                                </span>
                                            </li>
                                            ) : (
                                                <li key={i} className={`list-group-item`}>

                                                    <span className="drawer-menu-icon-span">
                                                        <span className="drawer-menu-icon-div">
                                                            <MaterialIcon icon={menu.icon} />
                                                        </span>
                                                    </span>
                                                    <span className="drawer-menu-txt-container">
                                                        <a href={menu.path} target="_blank">
                                                            <span className="drawer-menu-txt">{menu.name}</span>
                                                        </a>
                                                    </span>
                                                </li>
                                            )
                                    )}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={`drawer-overlay absolute ${overlayClass}`} onClick={() => this.onOverlayClick()} />

                <div className={`relative w-100 ${defaultOpenClass}`}>
                    {navBar}
                    {this.props.children}
                </div>
            </div>
        )
    }
}


const mapStateToProps = state => ({
    userPicture: state.application.userPicture,
    notifications: state.application.notification
});

export default connect(mapStateToProps, { logout })(Drawer);


// WEBPACK FOOTER //
// ./src/components/Drawer/Drawer.jsx